import { render } from "./ListOfEndpoints.vue?vue&type=template&id=9e533e50&scoped=true&ts=true"
import script from "./ListOfEndpoints.ts?vue&type=script&lang=ts"
export * from "./ListOfEndpoints.ts?vue&type=script&lang=ts"

import "./ListOfEndpoints.vue?vue&type=style&index=0&id=9e533e50&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e533e50"]])

export default __exports__